import { ShareInterface } from './share.model';

export class EmailShare implements ShareInterface {
  constructor(protected readonly url: string) {}

  share(): void {
    const a = document.createElement('a');
    a.target = '_blank';
    a.href = `mailto:?body=${this.url}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
